export const DEFAULT_TOOLTIP_PROPS = {
  leaveDelay: 0,
  arrow: true,
}
